import React from "react";
import { Link } from "react-router-dom";
import { RiMovie2Line } from "react-icons/ri";

const Footer = () => {
  //destructuring the footer navigations into objects
  const Links = [
    {
      title: "Navigation",
      links: [
        {
          name: "Home",
          link: "/",
        },

        {
          name: "About Us",
          link: "/about-us",
        },

        {
          name: "Contact Us",
          link: "/contact-us",
        },

        {
          name: "Movies",
          link: "/movies",
        },
      ],
    },
    {
      title: "Top Categories",
      links: [
        {
          name: "Action",
          link: "#",
        },

        {
          name: "Romantic",
          link: "#",
        },

        {
          name: "Drama",
          link: "#",
        },

        {
          name: "Historical",
          link: "#",
        },
      ],
    },
    {
      title: "My Account",
      links: [
        {
          name: "Dashboard",
          link: "/dashboard",
        },

        {
          name: "My Favorite",
          link: "/favorite",
        },

        {
          name: "Profile",
          link: "/profile",
        },

        {
          name: "Change Password",
          link: "/password",
        },
      ],
    },
  ];
  return (
    //Footer details
    <div className="bg-dry py-4 border=t-2 border-black">
      <div className="container mx-2 px-2">
        <div className="grid grid-cols-2 md:grid-cols-7 xl:grid-cols-12 gap-5 sm:gap-9 lg:gap-11 xl:gap-7 py-10 justify-between">
          {Links.map((link, index) => (
            <div
              key={index}
              className="col-span-1 md:col-span-2 lg:col-span-3 pb-3.5 sm:pb-0"
            >
              <h3 className="text-md lg:leading-7 font-medium mb-4 sm:mb-5 lg:mb-6 pb-0.5">
                {link.title}
              </h3>
              <ul className="text-sm flex flex-col space-y-3">
                {link.links.map((text, index) => (
                  <li key={index} className="flex items-baseline">
                    <Link
                      to={text.link}
                      className="text-border inline-block w-full hover:text-subMain"
                    >
                      {text.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="pb-3.5 sm:pb-0 col-spn-1 md:col-span-2 lg:col-span-3">
            <Link
              className="flex font-bold text-subMain text-4xl md:text-6xl"
              to="/"
            >
              O{" "}
              <span className="flex text-xl md:text-2xl text-white py-2 md:py-4">
                scar'sTv
                <RiMovie2Line color="red" />
              </span>
            </Link>
            <p className="leading-7 text-xs md:text-sm text-border mt-1">
              <span>
                No: Eugene street Aroma, Awka <br /> Anambra State, AN 402102
              </span>
              <br />
              <span>Tel: 090 33 0606 78</span>
              <br />
              <span>Email: Oscarstv@gmail.com</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
